import { Field } from "formik";
import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";

export default function Communication(props) {
	return 	<React.Fragment>
				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm={4}>Email</Form.Label>
					<Col sm={8}>
						<Field isInvalid={ props.touched.Email && props.errors.Email } as={Form.Control} type="email" name="Email"></Field>
						<small className="text-danger">{ props.touched.Email && props.errors.Email }</small>
					</Col>
				</Form.Group>
				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm={4}>WhatsApp Number</Form.Label>
					<Col sm={8}>
						<InputGroup>
							<InputGroup.Text style={{ borderEndEndRadius: "0px", borderStartEndRadius: "0px" }} className="border-right-0">+27</InputGroup.Text>
							<Field maxLength={10} isInvalid={ props.touched.CellphoneNumber && props.errors.CellphoneNumber }  as={Form.Control} name="CellphoneNumber"></Field>
						</InputGroup>
						<small className="text-danger">{ props.touched.CellphoneNumber && props.errors.CellphoneNumber }</small>
					</Col>
				</Form.Group>
			</React.Fragment>
}